import { LogLevel } from '@/lib/logger/logger.constants'
import type { Transport } from '@/lib/logger/logger.types'
import { format } from 'date-fns'
import { prepareMetadata } from './utils'

export const consoleTransport: Transport = (level, message, metadata, timestamp) => {
	const extra = Object.keys(metadata ?? {}).length
		? ` ${JSON.stringify(prepareMetadata(metadata), null)}  `
		: ''

	const log = {
		[LogLevel.Debug]: console.debug,
		[LogLevel.Info]: console.info,
		[LogLevel.Log]: console.log,
		[LogLevel.Warn]: console.warn,
		[LogLevel.Error]: console.error,
	}[level]

	if (message instanceof Error) {
		console.info(`${format(timestamp, 'HH:mm:ss')} ${message.toString()}${extra}`)
		log(message)
	} else {
		log(`${format(timestamp, 'HH:mm:ss')} ${message.toString()}${extra}`)
	}
}
